
export const ID = '9d4286cc-d4ec-4cd1-981e-280779470827';

export const NAME = 'Email Contact Form            (Only for Marinas)';
